import { parseISO } from "date-fns";

// Converts format of date strings to YYYY-MM-DD

const DateHelpers = {

   // Date String to Display in Date Pickers
   getFormattedDate: function (dateString) {
      if (dateString != "") {
         const date = new Date(dateString);
         date.toISOString();
         let year = date.getUTCFullYear();
         let month = (1 + date.getUTCMonth()).toString().padStart(2, '0');
         let day = date.getUTCDate().toString().padStart(2, '0');
         return year + '-' + month + '-' + day;
      }
      else {
         return null
      }
   },

   getDisplayDateShort: function (dateString) {
      const date = new Date(dateString)
      date.toISOString();
      let year = date.getUTCFullYear();
      let month = (1 + date.getUTCMonth()).toString().padStart(2, '0');
      let day = date.getUTCDate().toString().padStart(2, '0');
      return month + '/' + day + '/' + year;
   }
   ,

   // Date String to Display in UI 
   getDisplayDate: function (date) {
      console.log("Date Helper Date", date)
      date = new Date(date);
      let formattedDate = date.toLocaleDateString('en-us', { day: "numeric", month: "long", year: "numeric" })
      return formattedDate;
   },


   getEventStartMonthandDay: function (date) {
      date = new Date(date)
      let formattedDate = date.toLocaleDateString('en-us', { day: "numeric", month: "long" })
      return formattedDate;
   },

   getEventEndDayAndYear: function (date) {
      date = new Date(date)
      let formattedDate = date.toLocaleDateString('en-us', { year: "numeric", day: "numeric", month: "long" })
      return formattedDate;
   },

   // Single-day events (e.g. Independence Day Retreat, Day of Champions) store the same
   // calendar date as both begin_date and end_date. Showing "July 4 - July 4, 2026" reads
   // like a mistake, so those events display just the one date.
   getEventDateRange: function (begin, end) {
      const beginDate = new Date(begin)
      const endDate = new Date(end)
      if (beginDate.toDateString() === endDate.toDateString()) {
         return this.getEventEndDayAndYear(begin)
      }
      return this.getEventStartMonthandDay(begin) + " - " + this.getEventEndDayAndYear(end)
   },

   determineCamperAgeInYears: function(camperBirthdate) {
     
      console.log('birthday string', camperBirthdate)
      var bdString = camperBirthdate
      if (!bdString) {
         console.log("Birth date is missing");
         return null;
      }
      var birthDate = new Date(bdString)
      if (isNaN(birthDate.getTime())) {
         console.log("Invalid birth date:", bdString);
         return null;
      }

      // var modifiedBirthDate = birthDate.getTime()
      const currentDate = new Date();
      const differenceInYears = Math.floor(
         (currentDate - birthDate) / (1000 * 3600 * 24 * 365)
      );
   
      console.log("difference in years", differenceInYears)
      return differenceInYears;
      // catch(error) {
      // console.error("Missing eventInfo data");
      // return null;
      // }
   },


   subtractFromDate: function(date, number){
      let yearLimit = (date.getFullYear() - number)
      let lowestDate = new Date()
      lowestDate.setFullYear(yearLimit)
      return (lowestDate)
   },

   determineDifferenceFromCurrentDate: function(date) {
      var birthDate = new Date(date)
      var modifiedBirthDate = birthDate.getTime()
      var currentDate = new Date();
      var modifiedCurrentDate = currentDate.getTime();
      var math = modifiedCurrentDate - modifiedBirthDate
      var difference = Math.round(math / (1000 * 3600 * 24))
      console.log("difference", difference)
      var differenceInYears = Math.trunc(difference / 365);
      console.log("difference in years", differenceInYears)
      return differenceInYears
   }

}

export default DateHelpers;
